const logoutChannel = new BroadcastChannel('logout');

export const communicationlogin = () => {
  logoutChannel.postMessage('Logout');
  localStorage.removeItem('accessToken');
  window.location.href = window.location.origin + '/login';
};
